import { render, staticRenderFns } from "./GoPage.vue?vue&type=template&id=4e1b9e0f&scoped=true"
import script from "./GoPage.vue?vue&type=script&lang=js"
export * from "./GoPage.vue?vue&type=script&lang=js"
import style0 from "./GoPage.vue?vue&type=style&index=0&id=4e1b9e0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1b9e0f",
  null
  
)

export default component.exports